const KEY_ESC = "Escape";

export default {
  data() {
    return { isFullscreen: false };
  },
  computed: {
    fullscreenIcon() {
      return this.isFullscreen ? "fa-compress" : "fa-expand";
    },
    fullscreenLabel() {
      return this.isFullscreen ? "ออกจากเต็มจอ" : "ขยายเต็มจอ";
    },
    fullscreenButtonVariant() {
      return this.isFullscreen ? "secondary" : "outline-secondary";
    },
  },
  methods: {
    async toggleFullscreen() {
      if (this.isFullscreen) {
        await this.exitFullscreen();
      } else {
        await this.enterFullscreen();
      }
    },
    async enterFullscreen() {
      this.isFullscreen = true;
      const el = this.$refs.fullscreenRoot;
      if (el && el.requestFullscreen && !document.fullscreenElement) {
        try {
          await el.requestFullscreen();
        } catch (e) {
          // Native API rejected (e.g. iframe / Safari quirks) — CSS class is enough.
        }
      }
    },
    async exitFullscreen() {
      this.isFullscreen = false;
      if (document.fullscreenElement) {
        try {
          await document.exitFullscreen();
        } catch (e) {
          /* ignore */
        }
      }
    },
    handleFullscreenEsc(e) {
      if (e.key === KEY_ESC && this.isFullscreen) {
        this.exitFullscreen();
      }
    },
    handleFullscreenChange() {
      if (!document.fullscreenElement && this.isFullscreen) {
        this.isFullscreen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("keydown", this.handleFullscreenEsc);
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleFullscreenEsc);
    document.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    );
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(() => {});
    }
  },
};
